import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public static readonly DEFAULT_LIFE = 15000;

  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  /** Same stream as PrimeNG `MessageService` (e.g. keyed toasts for update UI). */
  get messages$() {
    return this.messageService.messageObserver;
  }

  clear(key?: string): void {
    this.messageService.clear(key);
  }

  success(config?: ToastMessageOptions) {
    this.messageService.add({
      life: ToastService.DEFAULT_LIFE,
      ...config,
      severity: 'success',
      summary: this.translate.instant(config?.summary ?? 'success'),
      detail: this.translate.instant(config?.detail ?? 'updated'),
    });
  }

  error(config?: ToastMessageOptions) {
    this.messageService.add({
      life: ToastService.DEFAULT_LIFE,
      ...config,
      severity: 'error',
      summary: this.translate.instant(config?.summary ?? 'error'),
      detail: this.translate.instant(config?.detail ?? 'untitled_error'),
    });
  }

  warn(config?: ToastMessageOptions) {
    this.messageService.add({
      life: ToastService.DEFAULT_LIFE,
      ...config,
      severity: 'warn',
      summary: this.translate.instant(config?.summary ?? 'warning'),
      detail: this.translate.instant(config?.detail ?? 'warning'),
    });
  }

  info(config?: ToastMessageOptions) {
    this.messageService.add({
      life: ToastService.DEFAULT_LIFE,
      ...config,
      severity: 'info',
      summary: this.translate.instant(config?.summary ?? 'info'),
      detail: this.translate.instant(config?.detail ?? 'info'),
    });
  }
}
